export const ON_FETCH_PROGRAMS_FAIL = 'fetchProgramsFail';
export const ON_FETCH_PROGRAMS_SUCCESS = 'fetchProgramsSuccess';
export const ON_FETCH_PROGRAMS_START = 'fetchingProgramsStart';
export const UPDATE_VIEWED_PROGRAMS = 'fetchProgramsUpdatedViewed';

export const ON_FETCH_FEATURES_FAIL = 'fetchFeaturesFail';
export const ON_FETCH_FEATURES_SUCCESS = 'fetchFeaturesSuccess';
export const ON_FETCH_FEATURES_START = 'fetchingFeaturesStart';
export const UPDATE_VIEWED_FEATURES = 'fetchFeaturesUpdatedViewed';
